import { glideConfig } from "../../library/glide";

// Configuration constants
const DESKTOP_PER_VIEW = 4;
const MOBILE_PER_VIEW = 1;
const GAP = 16;
const MOBILE_BREAKPOINT = 768;

// Multi-instance Editors Picks widget; initializes for each [data-editors-picks-widget]
const editorsPicksSlider = () => {
    // === Slider ===
    const editorsPicks = document.querySelectorAll(
        "[data-editors-picks-plugin] .glide",
    );

    console.log({ editorsPicks });

    if (editorsPicks.length === 0) return;

    for (const plugin of editorsPicks) {
        const slidesCount = plugin.querySelectorAll(".glide__slide").length;
        glideConfig(plugin, {
            type: "carousel",
            perView: DESKTOP_PER_VIEW,
            gap: GAP,
            dragThreshold: false,
            swipeThreshold: false,
            rewind: false,
            breakpoints: {
                [MOBILE_BREAKPOINT]: {
                    type:
                        slidesCount <= MOBILE_PER_VIEW ? "slider" : "carousel",
                    perView: MOBILE_PER_VIEW,
                    focusAt: 0,
                    dragThreshold: true,
                    swipeThreshold: true,
                },
            },
        });
    }
};

const init = () => {
    editorsPicksSlider();
};

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
} else {
    init();
}

export { editorsPicksSlider };
